export default "__VITE_ASSET__B$CXXnsF__"